<template>
  <div id="products-page" class="min-vh-100 d-flex flex-column">
    <loading-component-s2 v-if="isLoading" />

    <main class="flex-grow-1">
      <section class="product-header py-5 py-md-5 bg-products">
        <div class="container oversized-container">
          <h1 class="sale-title font-weight-bold mb-2">
            All Products
          </h1>
          <p class="sale-subtitle">
            Save big on premium diesel engine components - Limited time deals!
          </p>
        </div>
      </section>

      <section class="container oversized-container pt-4 pb-3 products-section">
        <!-- <div class="d-flex flex-column flex-md-row flex-wrap align-items-start align-md-items-center justify-content-between mb-4">
          <div class="d-flex flex-wrap align-items-center mb-3 mb-md-0">
            <div class="mr-3 mb-2 mb-md-0">
              <label for="filter-brand" class="small text-muted mb-1 d-block">Brand</label>
              <select
                id="filter-brand"
                v-model="filters.brand"
                class="form-control form-control-sm"
                style="min-width: 180px;"
                @change="selectedFilter($event, 'brand')"
              >
                <option value="">All Brands</option>
                <option
                  v-for="brand in brands"
                  :key="brand.id"
                  :value="brand.id"
                >
                  {{ brand.name }}
                </option>
              </select>
            </div>
            <div class="mr-3 mb-2 mb-md-0">
              <label for="filter-category" class="small text-muted mb-1 d-block">Category</label>
              <select
                id="filter-category"
                v-model="filters.category"
                @change="selectedFilter($event, 'category')"
                class="form-control form-control-sm"
                style="min-width: 180px;"
              >
                <option value="">All Categories</option>
                <option
                  v-for="category in categories"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ category.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="d-inline-block align-items-center">
            <span class="mb-1 small text-muted mr-2">Sort by:</span><br />
            <select
              v-model="filters.sort_by"
              class="form-control form-control-sm"
              style="min-width: 180px;"
              @change="selectedFilter($event, 'sort_by')"
            >
              <option value="name">Name: A to Z</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
            </select>
          </div>
        </div> -->

        <div class="mb-4">
          <p class="small text-muted mb-0">
            Showing {{ totalProducts }} {{ totalProducts === 1 ? 'item' : 'items' }} on sale
          </p>
        </div>

        <div class="row">
          <div
            v-for="product in products"
            :key="product.id"
            class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4 box-product-s1"
            v-if="products.length > 0"
          >
            <router-link
              :to="'/product/'+$root._converToURL(product.name, product.id)"
              class="text-decoration-none text-dark"
            >
              <div class="card h-100 sale-product-card shadow-sm">
                <div class="position-relative overflow-hidden sale-product-img-wrap">
                  <img
                    src="public/images/pages/products/product.png"
                    class="card-img-top sale-product-img placed-backg"
                    :style="{ backgroundImage: 'url('+ (product.image ? product.image : 'public/images/pages/products/placeholder.svg') +')' }"
                  />
                  <!-- <span class="badge badge-danger position-absolute sale-discount-badge" v-if="product.price_offer">
                    -{{ $root.getPercentDiscount(product.price, product.price_offer) }}%
                  </span> -->
                  <span
                    v-if="product.inStock"
                    class="badge badge-accent position-absolute sale-stock-badge"
                  >
                    In stock
                  </span>
                  <!-- <span class="badge badge-danger position-absolute sale-stock-badge" v-else>Agotado</span> -->
                </div>
                <div class="card-body">
                  <div class="d-flex align-items-center mb-2">
                    <span class="text-muted small font-weight-medium mr-2" v-if="product.brand">{{ product.brand }}</span>
                    <span class="text-muted small mr-2" v-if="product.category">•</span>
                    <span class="text-muted small" v-if="product.category">{{ product.category }}</span>
                  </div>
                  <h3 class="card-title font-weight-semibold mb-2 sale-product-name">
                    {{ product.name }}
                  </h3>
                  <div class="d-flex align-items-baseline flex-wrap mt-3" v-if="$root.logged && product.distributor">
                    <h6 class="title-distributor"><i class="fa-regular fa-box mr-1 ic"></i> Distributor price</h6>
                    <span class="h4 font-weight-bold text-danger mr-1">
                      ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.distributor_unit_price) }}
                    </span>
                    <span class="usd text-danger">USD</span>
                    <span class="small text-muted w-100">1 piece</span>
                    <p
                      class="small wholesale-distributor mb-0 w-100"
                      v-if="product.wholesale_price && product.wholesale_quantity"
                    >
                      Wholesale: ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.wholesale_price) }} USD from {{ product.wholesale_quantity }} {{ product.wholesale_quantity === 1 ? 'piece' : 'pieces' }}
                    </p>
                  </div>
                  <div class="d-flex align-items-baseline flex-wrap mt-3" v-else-if="$root.logged">
                    <span class="h4 font-weight-bold mr-1" v-if="!product.price_offer">
                      ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}
                    </span>
                    <span class="h4 font-weight-bold text-danger mr-1" v-if="product.price_offer">
                      ${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_offer) }}
                    </span>
                    <span class="usd" :class="{ 'text-danger': product.price_offer }">USD</span>
                  </div>
                  <p class="small mt-1 mb-0 sku">{{ product.sku }}</p>
                </div>
                <div class="card-footer bg-white border-top">
                  <a class="btn btn-accent btn-block" to="">
                    READ
                    <!-- {{ product.inStock ? 'Add to cart' : 'Out of stock' }} -->
                  </a>
                </div>
              </div>
            </router-link>
          </div>
        
          <div class="col-12 col-pagination mt-2" v-if="products.length > 0">
            <b-pagination-nav class="nav-pagination" :link-gen="linkGen" :number-of-pages="totalPages" use-router></b-pagination-nav>
          </div>

          <div class="col-12" v-if="products.length == 0">
            <div class="alert alert-light text-center py-5">
              Products not found.
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,
      totalPages: 1,
      totalProducts: 0,

      filters: {
        brand: '',
        category: '',
        page: 1,
        sort_by: 'name',
      },

      products: [
        // {
        //   id: 'DEC3064291',
        //   name: 'Cummins N14 Plus Electric/Mechanical Crankshaft Luther',
        //   brand: 'Cummins',
        //   category: 'Crankshaft',
        //   originalPrice: 1249.99,
        //   price: 999.99,
        //   discount: 20,
        //   image: 'public/images/pages/products/crankshaft-engine-part.jpg',
        //   inStock: true,
        // },
      ],

      categories: [
        // { name: 'All Categories', id: '' },
        // { name: 'Cylinder Head', id: '5' },
      ],

      brands: [
        // { name: 'All Brands', id: '' },
      ],
    }
  },

  methods: {
    getProducts() {
      this.filters.category = this.$route.query.c || '';
      this.filters.brand = this.$route.query.b || '';
      this.filters.page = this.$route.query.page || 1;
      this.filters.keywords = this.$route.query.k || '';
      this.isLoading = true;

      axios.post(tools.url('/api/products?page='+this.filters.page), this.filters).then(({data}) =>{
        this.categories = data.categories;
        this.brands = data.brands;
        this.products = data.products.data;
        this.totalPages = data.products.last_page;
        this.totalProducts = data.products.total;
        setTimeout(() => {
          this.isLoading = false;
        }, 400);
      });
    },

    linkGen(pageNum) {
      let catID = (this.filters.category == '') ? '' : this.filters.category;
      let brandID = (this.filters.brand == '') ? '' : this.filters.brand;
      let sortBy = (this.filters.sort_by == '') ? '' : this.filters.sort_by;

      return pageNum === 1 ? `?k=${this.filters.keywords}&c=${catID}&b=${brandID}&s=${sortBy}&page=${1}` : `?k=${this.filters.keywords}&c=${catID}&b=${brandID}&s=${sortBy}&page=${pageNum}`;
    },

    selectedFilter: function(event, type){
      const selectedID = event.target.value;

      if(type == 'brand'){
        this.$router.push({ query: { k: this.filters.keywords, c: this.filters.category, b: selectedID, s: this.filters.sort_by, page: 1 } });
      }
      if(type == 'category'){
        this.$router.push({ query: { k: this.filters.keywords, c: selectedID, b: this.filters.brand, s: this.filters.sort_by, page: 1 } });
      }
      if(type == 'sort_by'){
        this.$router.push({ query: { k: this.filters.keywords, c: this.filters.category, b: this.filters.brand, s: selectedID, page: 1 } });
      }
    },
  },

  beforeMount() {
    this.getProducts();
  },

  watch: {
    $route(to, from) {
      this.getProducts();
    },
  },
}
</script>
